export const applicationNotesRoute = '/employer/applications/notes/';
